import { defineMessages } from 'react-intl';

export const giftCardCheckoutSubmitMessages = defineMessages({
  total: {
    defaultMessage: 'Buy now',
    description: 'Gift Card Checkout Form | Submit | CTA label',
  },
});
